<template>
  <b-modal
    :id="id"
    ref="modal"
    size="xl"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    dialog-class="modal-xl-custom"
    @shown="onShown"
  >
    <!-- ─── HEADER (Padrão Premium) ─── -->
    <div class="report-header-premium">
      <div class="report-header-premium__info">
        <div class="report-header-premium__icon">
          <i class="fas fa-chart-line"></i>
        </div>
        <div>
          <h5 class="report-header-premium__title">Análise Gerencial de Comissões</h5>
          <div class="d-flex align-items-center">
            <span class="report-header-premium__sub">{{ vendedorNome }} | {{ formatDataBR(dt1) }} - {{ formatDataBR(dt2) }}</span>
            <b-badge v-if="soQuitados" variant="success" pill class="ml-2 py-1 px-2 border border-white-50 shadow-sm" style="font-size: 0.65rem; vertical-align: middle;">
              <i class="fas fa-check-circle mr-1"></i> APENAS QUITADOS
            </b-badge>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center gap-3">
        <b-button variant="link" class="report-header-premium__close" @click="fechar">
          <i class="fa fa-times"></i>
        </b-button>
      </div>
    </div>

    <!-- ─── CORPO DO RELATÓRIO ─── -->
    <div class="report-container bg-soft-gray overflow-auto" style="max-height: 85vh;">
      
      <!-- KPIs Rápidos -->
      <div class="p-4 pb-0">
        <b-row>
          <b-col md="3">
            <div class="kpi-card-premium">
              <small>Total de Vendas (Bruto)</small>
              <div class="d-flex align-items-end justify-content-between">
                <h4 class="mb-0">{{ formatBRL(resumo.totalBruto) }}</h4>
                <i class="fas fa-shopping-bag text-primary-soft"></i>
              </div>
            </div>
          </b-col>
          <b-col md="3">
            <div class="kpi-card-premium">
              <small>Total Comissões</small>
              <div class="d-flex align-items-end justify-content-between">
                <h4 class="mb-0 text-success">{{ formatBRL(resumo.totalComissao) }}</h4>
                <i class="fas fa-money-bill-wave text-success-soft"></i>
              </div>
            </div>
          </b-col>
          <b-col md="3">
            <div class="kpi-card-premium">
              <small>% Médio de Comissão</small>
              <div class="d-flex align-items-end justify-content-between">
                <h4 class="mb-0">{{ resumo.percentualMedio.toFixed(2) }}%</h4>
                <i class="fas fa-percentage text-info-soft"></i>
              </div>
            </div>
          </b-col>
          <b-col md="3">
            <div class="kpi-card-premium">
              <small>Ticket Médio / Item</small>
              <div class="d-flex align-items-end justify-content-between">
                <h4 class="mb-0">{{ formatBRL(resumo.ticketMedioItem) }}</h4>
                <i class="fas fa-tag text-warning-soft"></i>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Seção de Gráficos -->
      <div class="p-4">
        <b-row>
          <!-- Gráfico de Evolução -->
          <b-col md="8">
            <b-card class="border-0 shadow-sm mb-4">
              <template #header>
                <div class="d-flex align-items-center">
                  <i class="fas fa-chart-area mr-2 text-primary"></i>
                  <span class="font-weight-bold">Evolução de Vendas e Comissões</span>
                </div>
              </template>
              <div style="height: 300px;">
                <canvas ref="chartEvolucao"></canvas>
              </div>
            </b-card>
          </b-col>
          
          <!-- Gráfico por Grupo -->
          <b-col md="4">
            <b-card class="border-0 shadow-sm mb-4">
              <template #header>
                <div class="d-flex align-items-center">
                  <i class="fas fa-chart-pie mr-2 text-success"></i>
                  <span class="font-weight-bold">Comissão por Grupo</span>
                </div>
              </template>
              <div style="height: 300px;">
                <canvas ref="chartGrupos"></canvas>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <!-- Tabela de Resumo por Grupo -->
          <b-col md="12">
            <b-card class="border-0 shadow-sm">
              <template #header>
                <div class="d-flex align-items-center">
                  <i class="fas fa-list-ul mr-2 text-info"></i>
                  <span class="font-weight-bold">Desempenho por Grupo de Produtos</span>
                </div>
              </template>
              <b-table
                :items="resumoGrupos"
                :fields="fieldsGrupos"
                hover
                striped
                responsive
                class="mb-0"
                head-variant="light"
              >
                <template #cell(VL_BRUTO)="data">
                  {{ formatBRL(data.value) }}
                </template>
                <template #cell(VL_COMISSAO)="data">
                  <span class="text-success font-weight-bold">{{ formatBRL(data.value) }}</span>
                </template>
                <template #cell(PCT_PARTICIPACAO)="data">
                  <b-progress :value="data.value" max="100" show-value variant="info" style="height: 12px;" />
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </div>

    </div>

    <!-- ─── FOOTER ─── -->
    <div class="p-3 bg-white border-top d-flex justify-content-between align-items-center">
      <div class="text-muted small pl-3">
        <i class="fas fa-info-circle mr-1"></i> Análise gerencial baseada em vendas emitidas no período.
      </div>
      <div>
        <b-button variant="outline-secondary" pill class="px-4 font-weight-bold mr-2" @click="fechar">
          FECHAR
        </b-button>
        <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" @click="imprimirAnalise()">
          <i class="fa fa-print mr-1"></i> IMPRIMIR ANÁLISE
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'

export default {
  name: 'RelatorioComissaoVendedorModal',
  props: {
    id: { type: String, default: 'modal-relatorio-comissao' },
    dt1: { type: String, required: true },
    dt2: { type: String, required: true },
    vendedorId: { type: [Number, String], required: true },
    vendedorNome: { type: String, default: '' },
    dados: { type: Array, default: () => [] },
    soQuitados: { type: Boolean, default: false }
  },
  data() {
    return {
      charts: {
        evolucao: null,
        grupos: null
      },
      fieldsGrupos: [
        { key: 'GRUPO', label: 'Grupo de Produto', sortable: true },
        { key: 'QTD_ITENS', label: 'Qtd Itens', class: 'text-center' },
        { key: 'VL_BRUTO', label: 'Total Bruto', class: 'text-right' },
        { key: 'VL_COMISSAO', label: 'Comissão', class: 'text-right' },
        { key: 'PCT_PARTICIPACAO', label: '% na Comissão', class: 'text-center', thStyle: { width: '150px' } }
      ]
    }
  },
  computed: {
    resumo() {
      const totalBruto = this.dados.reduce((acc, it) => acc + (it.VL_TOTAL_BRUTO || 0), 0)
      const totalComissao = this.dados.reduce((acc, it) => acc + (it.VALOR_COMISSAO || 0), 0)
      const percentualMedio = totalBruto > 0 ? (totalComissao / totalBruto) * 100 : 0
      const ticketMedioItem = this.dados.length > 0 ? totalBruto / this.dados.length : 0
      return { totalBruto, totalComissao, percentualMedio, ticketMedioItem }
    },
    resumoGrupos() {
      const gruposMap = {}
      let totalComissaoGeral = 0
      this.dados.forEach(it => {
        const nome = it.NOME_GRUPO || 'DIVERSOS'
        if (!gruposMap[nome]) {
          gruposMap[nome] = { GRUPO: nome, QTD_ITENS: 0, VL_BRUTO: 0, VL_COMISSAO: 0 }
        }
        gruposMap[nome].QTD_ITENS += 1
        gruposMap[nome].VL_BRUTO += (it.VL_TOTAL_BRUTO || 0)
        gruposMap[nome].VL_COMISSAO += (it.VALOR_COMISSAO || 0)
        totalComissaoGeral += (it.VALOR_COMISSAO || 0)
      })
      return Object.values(gruposMap)
        .map(g => ({
          ...g,
          PCT_PARTICIPACAO: totalComissaoGeral > 0 ? (g.VL_COMISSAO / totalComissaoGeral) * 100 : 0
        }))
        .sort((a, b) => b.VL_COMISSAO - a.VL_COMISSAO)
    }
  },
  methods: {
    formatBRL(v) {
      return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatDataBR(v) {
      if (!v) return '-'
      return moment(v).format('DD/MM/YYYY')
    },
    fechar() {
      this.$bvModal.hide(this.id)
    },
    async onShown() {
      this.$nextTick(async () => {
        this.renderCharts()
      })
    },
    renderCharts() {
      this.renderEvolucao()
      this.renderGrupos()
    },
    renderEvolucao() {
      const ctx = this.$refs.chartEvolucao.getContext('2d')
      if (this.charts.evolucao) this.charts.evolucao.destroy()
      const diasMap = {}
      this.dados.forEach(it => {
        const dia = moment(it.DT_SAIDA).format('DD/MM')
        if (!diasMap[dia]) diasMap[dia] = { bruto: 0, comissao: 0 }
        diasMap[dia].bruto += (it.VL_TOTAL_BRUTO || 0)
        diasMap[dia].comissao += (it.VALOR_COMISSAO || 0)
      })
      const labels = Object.keys(diasMap).sort()
      const dataBruto = labels.map(l => diasMap[l].bruto)
      const dataComissao = labels.map(l => diasMap[l].comissao)
      this.charts.evolucao = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Comissão (R$)',
              data: dataComissao,
              type: 'line',
              borderColor: '#28a745',
              backgroundColor: 'transparent',
              yAxisID: 'y-comissao',
              pointBackgroundColor: '#28a745',
              tension: 0.4
            },
            {
              label: 'Vendas (R$)',
              data: dataBruto,
              backgroundColor: 'rgba(0, 123, 255, 0.2)',
              borderColor: '#007bff',
              borderWidth: 1,
              yAxisID: 'y-vendas'
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                id: 'y-vendas',
                position: 'left',
                ticks: { beginAtZero: true, callback: value => this.formatBRL(value) }
              },
              {
                id: 'y-comissao',
                position: 'right',
                gridLines: { drawOnChartArea: false },
                ticks: { beginAtZero: true, callback: value => this.formatBRL(value) }
              }
            ]
          }
        }
      })
    },
    renderGrupos() {
      const ctx = this.$refs.chartGrupos.getContext('2d')
      if (this.charts.grupos) this.charts.grupos.destroy()
      const data = this.resumoGrupos.slice(0, 8)
      const labels = data.map(g => g.GRUPO)
      const values = data.map(g => g.VL_COMISSAO)
      this.charts.grupos = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: ['#007bff', '#28a745', '#17a2b8', '#ffc107', '#dc3545', '#6610f2', '#e83e8c', '#fd7e14']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 10 } }
        }
      })
    },
    async obterEmpresaPreferencial() {
      try {
        const { data } = await this.$http.get('/api/protected/empresa/getPreferencial')
        return Array.isArray(data) ? data[0] : data
      } catch (e) {
        return { FANTASIA: 'CECWEB', RAZAO: 'CECWEB SISTEMA' }
      }
    },
    montarHtmlRelatorio(empresa) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || 'SISTEMA'
      const dataEmissao = moment().format('DD/MM/YYYY HH:mm')
      const imgEvolucao = this.$refs.chartEvolucao.toDataURL('image/png')
      const imgGrupos = this.$refs.chartGrupos.toDataURL('image/png')
      let linhasTabela = ''
      this.resumoGrupos.forEach((g, i) => {
        linhasTabela += '<tr>' +
          '<td>' + (i + 1) + '</td>' +
          '<td>' + g.GRUPO + '</td>' +
          '<td style="text-align:center;">' + g.QTD_ITENS + '</td>' +
          '<td style="text-align:right;">' + this.formatBRL(g.VL_BRUTO) + '</td>' +
          '<td style="text-align:right; font-weight:700; color:#28a745;">' + this.formatBRL(g.VL_COMISSAO) + '</td>' +
          '<td style="text-align:center;">' + g.PCT_PARTICIPACAO.toFixed(1) + '%</td>' +
          '</tr>'
      })

      return '<!doctype html>' +
      '<html>' +
      '<head>' +
      '  <meta charset="utf-8">' +
      '  <title>Análise Gerencial de Comissões</title>' +
      '  <style>' +
      '    body { font-family: sans-serif; margin: 20px; color: #333; font-size: 12px; }' +
      '    .header { border-bottom: 2px solid #333; padding-bottom: 10px; margin-bottom: 20px; display: flex; justify-content: space-between; }' +
      '    .report-title { text-align: center; font-size: 16px; font-weight: 700; text-transform: uppercase; margin: 20px 0; background: #f8f9fa; padding: 10px; border: 1px solid #ddd; }' +
      '    .kpi-row { display: flex; gap: 15px; margin-bottom: 20px; }' +
      '    .kpi-card { flex: 1; border: 1px solid #ddd; padding: 12px; border-radius: 4px; background: #fff; }' +
      '    .kpi-card small { display: block; font-size: 9px; text-transform: uppercase; color: #888; margin-bottom: 5px; font-weight: 700; }' +
      '    .kpi-card div { font-size: 16px; font-weight: 800; }' +
      '    .charts-row { display: flex; gap: 20px; margin-bottom: 30px; }' +
      '    .chart-box { flex: 1; border: 1px solid #eee; padding: 10px; text-align: center; }' +
      '    .chart-box h3 { font-size: 11px; margin-bottom: 10px; text-transform: uppercase; color: #444; border-bottom: 1px solid #eee; padding-bottom: 5px; }' +
      '    .chart-img { max-width: 100%; height: auto; max-height: 250px; }' +
      '    .data-table { width: 100%; border-collapse: collapse; margin-top: 10px; }' +
      '    .data-table th, .data-table td { border: 1px solid #ddd; padding: 8px; font-size: 11px; }' +
      '    .data-table th { background: #f2f2f2; text-align: left; text-transform: uppercase; }' +
      '    .footer { margin-top: 40px; border-top: 1px solid #ddd; padding-top: 10px; font-size: 9px; color: #999; display: flex; justify-content: space-between; }' +
      '  </style>' +
      '</head>' +
      '<body>' +
      '  <div class="header">' +
      '    <div class="header-left"><h1>' + (empresa.FANTASIA || 'CECWEB') + '</h1><span>' + (empresa.RAZAO || '') + '</span></div>' +
      '    <div class="header-right"><div><strong>Emissor:</strong> ' + nomeUsuario + '</div><div><strong>Data:</strong> ' + dataEmissao + '</div></div>' +
      '  </div>' +
      '  <div class="report-title">Relatório de Análise Gerencial de Comissões</div>' +
      '  <div style="margin-bottom: 15px; font-size: 13px;">' +
      '    <strong>Vendedor:</strong> ' + this.vendedorNome + '<br>' +
      '    <strong>Período:</strong> ' + this.formatDataBR(this.dt1) + ' até ' + this.formatDataBR(this.dt2) + '<br>' +
      '    <strong>Filtro Financeiro:</strong> ' + (this.soQuitados ? '<span style="color:#28a745; font-weight:700;">APENAS VENDAS QUITADAS</span>' : 'TODAS AS VENDAS') +
      '  </div>' +
      '  <div class="kpi-row">' +
      '    <div class="kpi-card"><small>Total Vendas (Bruto)</small><div>' + this.formatBRL(this.resumo.totalBruto) + '</div></div>' +
      '    <div class="kpi-card"><small>Total Comissões</small><div style="color:#28a745;">' + this.formatBRL(this.resumo.totalComissao) + '</div></div>' +
      '    <div class="kpi-card"><small>% Médio Comissão</small><div>' + this.resumo.percentualMedio.toFixed(2) + '%</div></div>' +
      '    <div class="kpi-card"><small>Ticket Médio / Item</small><div>' + this.formatBRL(this.resumo.ticketMedioItem) + '</div></div>' +
      '  </div>' +
      '  <div class="charts-row">' +
      '    <div class="chart-box"><h3>Evolução de Vendas e Comissões</h3><img src="' + imgEvolucao + '" class="chart-img"></div>' +
      '    <div class="chart-box" style="flex: 0 0 35%;"><h3>Comissão por Grupo</h3><img src="' + imgGrupos + '" class="chart-img"></div>' +
      '  </div>' +
      '  <div style="font-weight:700; text-transform:uppercase; font-size:11px; margin-bottom:10px;">Desempenho por Grupo de Produtos</div>' +
      '  <table class="data-table"><thead><tr><th style="width:30px;">#</th><th>Grupo de Produto</th><th style="width:80px; text-align:center;">Qtd Itens</th><th style="width:120px; text-align:right;">Total Bruto</th><th style="width:120px; text-align:right;">Comissão</th><th style="width:100px; text-align:center;">% Partic.</th></tr></thead>' +
      '  <tbody>' + linhasTabela + '</tbody></table>' +
      '  <div class="footer"><div>CECWEB SISTEMA COMERCIAL</div><div>Página 1 de 1</div></div>' +
      '  <script>window.onload = function() { window.print(); }<\/script>' +
      '</body>' +
      '</html>'
    },
    async imprimirAnalise() {
      const janela = window.open('', '_blank')
      if (!janela) {
        this.$bvToast.toast('Navegador bloqueou a abertura do relatório.', { variant: 'warning' })
        return
      }
      try {
        const empresa = await this.obterEmpresaPreferencial()
        const html = this.montarHtmlRelatorio(empresa)
        janela.document.open()
        janela.document.write(html)
        janela.document.close()
      } catch (err) {
        janela.close()
        this.$bvToast.toast('Erro ao gerar relatório impresso', { variant: 'danger' })
      }
    }
  },
  beforeDestroy() {
    Object.values(this.charts).forEach(c => c && c.destroy())
  }
}
</script>

<style scoped>
.report-header-premium {
  display: flex; align-items: center; justify-content: space-between;
  padding: 1.5rem 2rem;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: #fff;
}
.report-header-premium__info { display: flex; align-items: center; gap: 1.25rem; }
.report-header-premium__icon {
  width: 48px; height: 48px;
  background: rgba(255,255,255,0.08);
  border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.25rem; color: #38bdf8;
}
.report-header-premium__title { margin: 0; font-weight: 800; font-size: 1.25rem; text-transform: uppercase; letter-spacing: 0.5px; }
.report-header-premium__sub { font-size: 0.9rem; color: rgba(255,255,255,0.5); }
.report-header-premium__close { color: rgba(255,255,255,0.4); font-size: 1.25rem; padding: 0; transition: color 0.2s; }
.report-header-premium__close:hover { color: #fff; }
.report-container { background-color: #f1f5f9; }
.kpi-card-premium {
  background: #fff;
  padding: 1.25rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  margin-bottom: 1.5rem;
}
.kpi-card-premium small { display: block; text-transform: uppercase; font-weight: 700; color: #94a3b8; font-size: 0.7rem; margin-bottom: 0.5rem; }
.kpi-card-premium h4 { font-weight: 800; letter-spacing: -0.5px; }
.kpi-card-premium i { font-size: 1.5rem; opacity: 0.2; }
.text-primary-soft { color: #007bff; }
.text-success-soft { color: #28a745; }
.text-info-soft { color: #17a2b8; }
.text-warning-soft { color: #ffc107; }
.bg-soft-gray { background-color: #f8fafc; }
.gap-3 { gap: 1rem; }
.report-container::-webkit-scrollbar { width: 8px; }
.report-container::-webkit-scrollbar-track { background: #f1f5f9; }
.report-container::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
.report-container::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
@media print {
  .report-header-premium__close, .p-3.bg-white.border-top { display: none !important; }
  .report-container { max-height: none !important; overflow: visible !important; }
  .report-header-premium { background: #000 !important; color: #fff !important; -webkit-print-color-adjust: exact; }
  body { background: #fff !important; }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/RelatorioComissaoVendedorModal.vue